import React from 'react';

import { styled } from '@mui/material/styles';
import { Create } from 'react-admin';

const StyledCreate = styled(Create)({
    maxWidth: 'none',
});

const MaxWidthCreate = (props) => {
    return (
        <StyledCreate
            {...props}
        />
    );
};

export default MaxWidthCreate;
